/* eslint-disable no-unused-vars */

function log(...msg) {
	if (debugMode === "true") {
		// eslint-disable-next-line no-console
		console.log(...msg);
	}
}

function addScript(src, callback) {
	if (!src) return;
	const loading = document.getElementById("loading");
	loading.classList.remove("hide");

	const script = document.createElement("script");
	script.setAttribute("src", src);
	document.body.appendChild(script);
	script.onload = () => {
		loading.classList.add("hide");
		if (callback && typeof callback === "function") callback();
	};
	script.onerror = () => {
		loading.classList.add("hide");
		console.error(`Error loading script ${src}`);
	};
}

function addStyle(src, callback) {
	if (!src) return;
	const loading = document.getElementById("loading");
	loading.classList.remove("hide");

	const link = document.createElement("link");
	link.setAttribute("rel", "stylesheet");
	link.setAttribute("href", src);
	document.head.appendChild(link);
	link.onload = () => {
		loading.classList.add("hide");
		if (callback && typeof callback === "function") callback();
	};
	link.onerror = () => {
		loading.classList.add("hide");
		console.error(`Error loading style ${src}`);
	};
}

/**
 * POQ integration
 * @type {{init(): void, hideElements(): void, removeAppsFlyer(): void}}
 */
const POQ = {
	hideElements() {
		const elsStr = [".header", "header", ".upper-nav", "footer", ".footer", "#breadcrumbs", ".account-details"];
		elsStr.forEach((v) => {
			const els = document.querySelectorAll(v);
			if (els.length > 0) {
				els.forEach((el) => {
					// eslint-disable-next-line no-param-reassign
					el.style.display = "none";
				});
			}
		});
		const main = document.querySelector("body > main");
		if (main) main.style.padding = "2rem 0 6rem";
	},
	init() {
		const ua = navigator.userAgent || Request.UserAgent;
		if (ua && ua.match(/Arena|Poq/i)) {
			log("POQ mode.");
			window.isPoqMode = true;
			this.hideElements();

			log("Loading POQ scripts...");
			addScript("/assets/js/poq-bridge.js");
		}
	},
};
POQ.init();

function getCookie(cname) {
	const decodedCookie = decodeURIComponent(document.cookie);
	const match = decodedCookie.match(new RegExp(`(^| )${cname}=([^;]+)`));
	return match ? match[2] : null;
}

function setCookie(cname, cvalue, exdays = 1) {
	const d = new Date();
	d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
	const expires = `expires=${d.toUTCString()}`;
	document.cookie = `${cname}=${encodeURIComponent(cvalue)};${expires};path=/;SameSite=Lax`;
}

function removeCookie(cname) {
	setCookie(cname, "", -1);
}

function getUrlParam(param) {
	const params = new URL(document.location).searchParams;
	return params.get(param);
}

function removeUrlParam(param) {
	const url = new URL(document.location);
	const params = url.searchParams;
	if (!params.get(param)) return;

	params.delete(param);
	window.history.replaceState(null, "", url);
}

// eslint-disable-next-line no-unused-vars
function currencyFormat(value) {
	return new Intl.NumberFormat("en-GB", {
		style: "currency",
		currency: "GBP",
		trailingZeroDisplay: "stripIfInteger",
	})
		.format(value)
		.replace(".00", "");
}

function dateFormat(date) {
	return new Intl.DateTimeFormat("en-GB").format(date);
}

/**
 * Show modal
 *
 * @param {Object} modalParams
 * @param {string} modalParams.txtHeader header
 * @param {string} modalParams.txtBody txtBody
 * @param {string} modalParams.htmlBody htmlBody replaces txtBody
 * @param {{label: string, fn: function htmlClass: string}[]} modalParams.actions Actions
 */
function showModal({ txtHeader, txtBody, htmlBody, actions, wrapperClass, dontAllowDismiss }) {
	const originElement = document.activeElement;
	const container = document.createElement("div");
	const focusStatus = {
		focusableEls: [],
		focusId: 0,
	};

	const closeModal = () => {
		document.documentElement.classList.remove("stop-scrolling");
		document.body.removeChild(container);
		if (originElement) originElement.focus();
	};

	const getFocusableElements = () =>
		Array.from(
			container.querySelectorAll('a[href], button, input, textarea, select, [tabindex]:not([tabindex="-1"])')
		).filter((el) => !el.hasAttribute("disabled") && !el.getAttribute("aria-hidden"));

	const manageFocus = (direction = 0) => {
		if (focusStatus.focusableEls.length === 0) return;

		if (direction === 0) {
			focusStatus.focusId = 0;
		} else if (direction < 0) {
			// shift tab
			if (focusStatus.focusId > 0) {
				focusStatus.focusId -= 1;
			} else {
				// go to the last item
				focusStatus.focusId = focusStatus.focusableEls.length - 1;
			}
		} else if (direction > 0) {
			// tab
			if (focusStatus.focusId < focusStatus.focusableEls.length - 1) {
				focusStatus.focusId += 1;
			} else {
				// go to the first item
				focusStatus.focusId = 0;
			}
		}

		focusStatus.focusableEls[focusStatus.focusId].focus();
	};

	const onKeydown = (event) => {
		const { key, shiftKey } = event;
		switch (key) {
			case "Esc":
			case "Escape":
				if (!dontAllowDismiss) closeModal();
				break;
			case "Tab":
				manageFocus(shiftKey ? -1 : 1);
				event.stopPropagation();
				event.preventDefault();
				break;
			default:
				break;
		}
	};

	const onClick = (event) => {
		const dataId = event.target.getAttribute("data_id");
		switch (dataId) {
			case "arena_modal":
				if (!dontAllowDismiss) closeModal();
				break;
			default:
				break;
		}
	};

	const createModal = () => {
		document.documentElement.classList.add("stop-scrolling");
		const modalContent = document.createElement("div");
		const modalContentBody = document.createElement("div");
		const modalContentActions = document.createElement("div");
		const modalTitle = document.createElement("h2");

		container.classList.add("arena-modal");
		if (wrapperClass) container.classList.add(wrapperClass);
		modalContent.classList.add("arena-modal_content");
		modalContentBody.classList.add("arena-modal_body");
		modalContentActions.classList.add("arena-modal_actions");

		container.setAttribute("data_id", "arena_modal");
		modalContent.setAttribute("role", "dialog");
		modalContent.setAttribute("aria-modal", true);
		modalContent.setAttribute("aria-labelledby", "dialog_label");
		modalContent.setAttribute("aria-describedby", "dialog_content");
		modalTitle.setAttribute("id", "dialog_label");
		modalContentBody.setAttribute("id", "dialog_content");

		if (txtHeader) modalTitle.innerText = txtHeader;
		if (txtBody) modalContentBody.innerText = txtBody;
		// case use html will replace the txtBody
		if (htmlBody) modalContentBody.innerHTML = htmlBody;

		modalContent.appendChild(modalTitle);
		modalContent.appendChild(modalContentBody);
		container.appendChild(modalContent);
		const modalActions = [];
		if (actions && Array.isArray(actions)) {
			actions.forEach(({ label, fn, htmlClass }) => {
				if (label) {
					const actButton = document.createElement("button");
					actButton.setAttribute("class", htmlClass || "btn btn-dark");
					actButton.innerText = label;

					actButton.addEventListener("click", () => {
						if (typeof fn === "function") fn();
						closeModal();
					});

					modalActions.push(actButton);
				}
			});
		} else {
			// Adds a default close button
			const actButton = document.createElement("button");
			actButton.setAttribute("class", "btn btn-dark");
			actButton.innerText = "Close";
			actButton.addEventListener("click", () => {
				closeModal();
			});
			modalActions.push(actButton);
		}

		modalContentActions.append(...modalActions);
		modalContent.appendChild(modalContentActions);

		container.addEventListener("keydown", onKeydown);
		container.addEventListener("click", onClick);

		document.body.appendChild(container);

		// get all focusable elements in container
		focusStatus.focusableEls = getFocusableElements();
		manageFocus();
	};

	createModal();
	return container;
}

function tooltip() {
	const tooltips = document.querySelectorAll("[data-tip]");
	if (tooltips) {
		Array.from(tooltips).forEach((tip) => {
			tip.addEventListener("click", ({ target }) => {
				if (target.nodeName === "svg" || target.nodeName === "path") {
					target.closest("span").classList.toggle("open");
				} else {
					target.classList.toggle("open");
				}
			});
		});
	}
}

function checkForDiscountCode() {
	const couponParam = getUrlParam("discount");
	if (!couponParam) return;

	setCookie("Arena:DiscountCode", couponParam, 1);
	showModal({
		txtHeader: "Coupon Saved",
		txtBody: `Your discount code '${couponParam.toUpperCase()}' has been saved and, if applicable to your order, will be added at checkout`,
	});

	removeUrlParam("discount");
}

/**
 * Async XMLHttpRequest
 *
 * @param {Object} request
 * @param {string} request.url
 * @param {string} [request.method = 'GET']
 * @param {Object} [request.headers = {}]
 * @param {string} request.headers[].key
 * @param {string} request.headers[].value
 * @param {string} [request.data = null]
 *
 * @returns {Promise}
 */
function asyncRequest({ url, method = "GET", headers = {}, data = null }) {
	return new Promise((resolve, reject) => {
		const request = new XMLHttpRequest();
		request.open(method, url);
		Object.entries(headers).forEach(([key, value]) => {
			if (key && value) request.setRequestHeader(key, value);
		});

		request.send(data);

		request.onload = () => resolve(request);

		request.onerror = () => {
			reject(new Error(JSON.stringify({ status: request.status, response: request.responseText })));
		};
	});
}

class Core {
	constructor() {
		if (!siteId || !poqId || !apiUrl || !apiCalendar || !shopifyDomain)
			throw new Error("Missing required global vars.");
		// sessionStorage comes first because it is not possible to set cookies in the POQ(Webview),
		// so when the user is buying a gift subscription through the app sessionStorage will be used.
		this.checkoutId = sessionStorage.getItem("checkoutId") || getCookie("checkoutId") || "";
		this.minOrderValue = 16.99;
		this.apiUrl = apiUrl;
		this.apiCalendar = apiCalendar;
		this.costumerContactPhone = customerContactPhone;
		this.shopifyDomain = shopifyDomain;
		this.siteCode = window.isPoqMode ? poqId : siteId;
		this.checkoutObj = false;
		this.hasGreetingCard = false;
		this.subTotalOrderValue = 0;
		this.totalOrderValue = 0;
		this.customerToken = getCookie("accessToken");
		this.customerId = getCookie("customerId");
		this.customerObj = null;
		this.htmlEl = {
			cartBadge: document.getElementById("headerCartLink"),
			loading: document.getElementById("loading"),
			loginLinks: document.querySelectorAll("a[href='/account/login']"), // Array with desktop and mobile links
			registerLinks: document.querySelectorAll("a[href='/account/register']"), // Array with desktop and mobile links
		};
		this.errorAssistenceMsg = `Should you need further assistance please contact customer service on ${customerContactPhone}.`;
		this.errorsApiMsgMap = {
			NOT_ALLOWED_INCLUDE_NOUPSELL_WITH_OTHERS: (productToAddTitle, conflictedItem) =>
				[
					`Unfortunately, you cannot add <b>${productToAddTitle || "it"}</b> `,
					"to your basket as it can only be sent on its own. <br /><br />",
					this.errorAssistenceMsg,
				].join(""),
			NOT_ALLOWED_INCLUDE_LETTERBOX_WITH_OTHERS: (productToAddTitle, conflictedItem) =>
				[
					`Unfortunately, you cannot add <b>${productToAddTitle || "it"}</b> `,
					"to your basket as it can only be sent on its own. <br /><br />",
					this.errorAssistenceMsg,
				].join(""),
			NOT_ALLOWED_INCLUDE_WHEN_NOUPSELL_IN_CART: (productToAddTitle, conflictedItem) =>
				[
					`Unfortunately, you cannot add more items to this basket, <b>${conflictedItem || "it"} </b> `,
					"can only be shipped on it's own.<br /><br />",
					this.errorAssistenceMsg,
				].join(""),
			NOT_ALLOWED_INCLUDE_WHEN_LETTERBOX_IN_CART: (productToAddTitle, conflictedItem) =>
				[
					`Unfortunately, you cannot add more items to this basket, <b>${conflictedItem || "it"} </b> `,
					"can only be shipped on it's own.<br /><br />",
					this.errorAssistenceMsg,
				].join(""),
			default: () =>
				[
					`Unfortunately, you cannot add more items to this basket, <b>it</b> can only be shipped on it's own.<br /><br />`,
					this.errorAssistenceMsg,
				].join(""),
		};
		this.unexpectedError = {
			txtHeader: "AN UNEXPECTED ERROR OCCURRED!",
			htmlBody: [
				"We were unable to add the item to your cart, please refresh the page and try again.",
				this.errorAssistenceMsg,
			].join("<br>"),
		};
		this.updateCartBadge(getCookie("cartCount") || 0);
		this.updateAccountLinks();

		if (window.GA4DataLayer) {
			this.ga4Datalayer = window.GA4DataLayer;
			this.ga4Datalayer.pushLogState(this.customerId);
		}
		if (window.OmetriaTracker) {
			this.ometriaTracker = window.OmetriaTracker;
			this.ometriaTracker.identify(this.customerId);
		}
	}

	// Checkout methods

	async fetchCheckout() {
		log("fetching checkout...");
		try {
			if (!this.checkoutId) return this.clearCheckout();

			const url = `${this.apiUrl}/cart/fetch/?cartId=${encodeURIComponent(this.checkoutId)}&site=${
				this.siteCode
			}&v=${new Date().getTime()}`;

			const request = await asyncRequest({ url });

			if (!request || request.status !== 200) return this.clearCheckout();

			const checkout = JSON.parse(request.response);
			if (!checkout) return this.clearCheckout();

			this.checkoutObj = checkout.cart || false;

			const cartQtdItems = this.countCheckoutItems();
			if (cartQtdItems === 0) return this.clearCheckout();

			this.hasGreetingCard = !!this.countCheckoutItems("Greeting Card");

			this.subTotalOrderValue = parseFloat(checkout.cart.cost.subtotalAmount.amount);
			this.totalOrderValue = parseFloat(checkout.cart.cost.totalAmount.amount);

			this.updateCartBadge(cartQtdItems);
			await this.checkForSavedDiscountCode();
			if (this.ometriaTracker) this.ometriaTracker.setBasket(this.checkoutObj);
		} catch (error) {
			log(error);
			if (typeof Rollbar === "object") {
				Rollbar.error(error.message, error, { checkoutId: this.checkoutId, siteCode: this.siteCode });
			}
			return this.clearCheckout();
		}
		return this.checkoutObj;
	}

	apiErrorMessage(error) {
		if (typeof this.errorsApiMsgMap[error.code] === "function") {
			return this.errorsApiMsgMap[error.code](error.productToAddTitle, error.productInConflict);
		}

		return this.errorsApiMsgMap.default();
	}

	/**
	 * Returns the total items of a given Product Type or the total items in the checkout
	 *
	 * @param {string} [type]
	 * @returns {Number}
	 */
	countCheckoutItems(type) {
		const compare = (productType, compareType) => {
			if (type === "Greeting Card") {
				// "Poq still using productType === Card"
				return productType.toLowerCase() === compareType.toLowerCase() || productType.toLowerCase() === "card";
			}
			return productType.toLowerCase() === compareType.toLowerCase();
		};

		if (!this.checkoutObj) return 0;

		const {
			lines: { nodes },
		} = this.checkoutObj;

		const items = type
			? nodes.filter(
					({
						merchandise: {
							product: { productType },
						},
					}) => compare(productType, type)
			  )
			: nodes;

		return items.reduce((a, b) => a + (b.quantity || 0), 0);
	}

	checkCheckoutValid() {
		log("Checking valid checkout...");
		const qtdItems = this.countCheckoutItems();
		const qtdCards = this.countCheckoutItems("Greeting Card");
		const qtdLetterbox = this.countCheckoutItems("Letterbox");
		const qtdBouquet = this.countCheckoutItems("Bouquet");
		const qtdGiftSubs = this.countCheckoutItems("Gift Subscription");

		if (qtdCards > 1) return { valid: false, reason: "You should only have one greeting card in your cart." };

		if (qtdBouquet > 1) return { valid: false, reason: "You can only order one bouquet at a time." };

		if (qtdLetterbox > 1) return { valid: false, reason: "You can only order one box of flowers at a time." };

		if (qtdGiftSubs > 1) return { valid: false, reason: "You can only order one gift subscription at a time." };

		if (
			(qtdLetterbox === 1 && qtdCards === 1 && qtdItems > 2) ||
			(qtdLetterbox === 1 && qtdCards === 0 && qtdItems > 1)
		) {
			return { valid: false, reason: "When ordering letterbox flowers, you cannot order other items." };
		}

		if (
			(qtdGiftSubs === 1 && qtdCards === 1 && qtdItems > 2) ||
			(qtdGiftSubs === 1 && qtdCards === 0 && qtdItems > 1)
		) {
			return { valid: false, reason: "When ordering gift subscription flowers, you cannot order other items." };
		}

		if (qtdCards === 1 && qtdItems === 1) {
			return { valid: false, reason: "It is not possible to buy a card by itself." };
		}

		log("valid");
		return { valid: true };
	}

	checkMinOrder() {
		log("Checking minimum allowed order...");
		const amountPreDiscount = parseFloat(this.subTotalOrderValue);

		const errorMsg = `You need to spend at least ${currencyFormat(
			this.minOrderValue
		)}, your current total is ${currencyFormat(this.subTotalOrderValue)}.`;

		if (amountPreDiscount < this.minOrderValue) {
			return { valid: false, reason: errorMsg };
		}

		return { valid: true };
	}

	clearCheckout() {
		removeCookie("checkoutId");
		this.checkoutObj = false;
		this.checkoutId = false;
		this.updateCartBadge(0);
		return false;
	}

	/**
	 * @param {Object} payload
	 * @param {String} payload.site
	 * @param {String} [payload.cartId]
	 * @param {Object[]} payload.items
	 * @param {String} payload.items[].merchandiseId
	 * @param {Number} payload.items[].quantity
	 * @param {Object[]} [payload.items[].attributes]
	 * @param {String} payload.items[].attributes[].key
	 * @param {String} payload.items[].attributes[].value
	 * @returns
	 */
	async addItemsCart(payload) {
		try {
			const request = await asyncRequest({
				url: `${this.apiUrl}/cart/add-items`,
				method: "POST",
				headers: { "Content-Type": "application/json;charset=UTF-8" },
				data: JSON.stringify(payload),
			});

			if (!request || request.status !== 200) {
				log("Error when adding item to checkout", request.status, request.response);
				throw new Error("Error when adding item to checkout");
			}

			const response = JSON.parse(request.response);
			const { cart, error } = response;

			// Errors from api lambda
			if (error) return { result: false, error };

			const { id: checkoutId } = cart;

			if (!checkoutId) {
				log("Can not proceed without checkout ID");
				throw new Error("Can not proceed without checkout ID");
			}

			this.checkoutId = checkoutId;
			setCookie("checkoutId", checkoutId, 1);
			await this.fetchCheckout();

			return { result: true };
		} catch (error) {
			log("Product -> addItemsCart", error);
			if (typeof Rollbar === "object") {
				Rollbar.error(error.message, error, { context: this });
			}
			return { result: false };
		}
	}

	/**
	 * @param {Object} payload
	 * @param {String} payload.site
	 * @param {String} payload.cartId
	 * @param {String[]} payload.lineItemIds
	 * @returns
	 */
	async removeItemsCart(payload) {
		try {
			const request = await asyncRequest({
				url: `${this.apiUrl}/cart/remove-items`,
				method: "POST",
				headers: { "Content-Type": "application/json;charset=UTF-8" },
				data: JSON.stringify(payload),
			});

			if (!request || request.status !== 200) {
				log("Error when adding item to checkout", request.status, request.response);
				throw new Error("Error when adding item to checkout");
			}

			const response = JSON.parse(request.response);
			const { error } = response;

			// Errors from api lambda
			if (error) return { result: false, error };

			await this.fetchCheckout();
			return { result: true };
		} catch (error) {
			log("Product -> removeItemsCart", error);
			if (typeof Rollbar === "object") {
				Rollbar.error(error.message, error, { context: this });
			}
			return { result: false };
		}
	}

	/**
	 * @param {Object} payload
	 * @param {String} payload.site
	 * @param {String} payload.cartId
	 * @param {Object[]} payload.items
	 * @param {String} payload.items[].id - Cart line id
	 * @param {String} payload.items[].merchandiseId
	 * @param {Number} payload.items[].quantity
	 * @param {Object[]} [payload.items[].attributes]
	 * @param {String} payload.items[].attributes[].key
	 * @param {String} payload.items[].attributes[].value
	 * @returns
	 */
	async updateItemsCart(payload) {
		try {
			const request = await asyncRequest({
				url: `${this.apiUrl}/cart/update-items`,
				method: "POST",
				headers: { "Content-Type": "application/json;charset=UTF-8" },
				data: JSON.stringify(payload),
			});

			if (!request || request.status !== 200) {
				log("Error when adding item to checkout", request.status, request.response);
				throw new Error("Error when adding item to checkout");
			}

			const response = JSON.parse(request.response);
			const { error } = response;

			// Errors from api lambda
			if (error) return { result: false, error };

			await this.fetchCheckout();
			return { result: true };
		} catch (error) {
			log("Product -> updateItemsCart", error);
			if (typeof Rollbar === "object") {
				Rollbar.error(error.message, error, { context: this });
			}
			return { result: false };
		}
	}

	updateCartBadge(numItems = 0) {
		const cartIsEmpty = numItems === 0;
		const ariaLabel = cartIsEmpty ? "Your shopping cart is empty" : `${numItems} item(s) in shopping cart`;
		const badge = this.htmlEl.cartBadge.querySelector(".badge");
		const icon = this.htmlEl.cartBadge.querySelector("#cartIconSvg");
		this.htmlEl.cartBadge.setAttribute("aria-label", ariaLabel);
		badge.innerText = numItems;
		setCookie("cartCount", numItems, 1);
		icon.classList.toggle("basket", cartIsEmpty);
		icon.classList.toggle("flowers", !cartIsEmpty);
		badge.classList.toggle("hide", cartIsEmpty);
	}

	async checkForSavedDiscountCode() {
		try {
			const code = getCookie("Arena:DiscountCode");
			if (!code) return;

			const request = await asyncRequest({
				url: `${this.apiUrl}/cart/add-discounts/`,
				method: "POST",
				headers: { "Content-Type": "application/json;charset=UTF-8" },
				data: JSON.stringify({ cartId: this.checkoutId, discountCodes: [code], site: this.siteCode }),
			});

			if (!request || request.status !== 200) {
				log("Error when applying discount code to checkout", request.status, request.response);
				throw new Error("Error when applying discount code to checkout");
			}

			removeCookie("Arena:DiscountCode");
		} catch (error) {
			log("Checkout -> checkForSavedDiscountCode", error);
			if (typeof Rollbar === "object") {
				Rollbar.error(error.message, error, { context: this });
			}
		}
	}

	// Common customer methods

	async fetchCustomer() {
		if (!this.customerToken) return false;
		console.log("Fetching customer...");

		const request = await asyncRequest({
			url: `${this.apiUrl}/account/?token=${this.customerToken}&site=${this.siteCode}`,
			method: "GET",
		});

		if (!request || request.status !== 200 || !request.response || request.response === "null") {
			return this.clearCustomer();
		}

		this.customerObj = JSON.parse(request.response);
		this.customerId = this.customerObj.id;

		this.updateAccountLinks();
		return this.customerObj;
	}

	updateAccountLinks() {
		if (!this.htmlEl.loginLinks || !this.htmlEl.registerLinks) {
			log("Can't found account html link elements");
			return;
		}

		const loginLinks = Array.from(this.htmlEl.loginLinks);
		const registerLinks = Array.from(this.htmlEl.registerLinks);

		const replaceLink = (el, label, url) => {
			const svg = el.querySelector("svg");
			// eslint-disable-next-line no-param-reassign
			el.innerText = label;
			el.setAttribute("href", url);
			if (svg) el.prepend(svg);
		};

		// Simple check by cookie
		if (this.customerToken) {
			loginLinks.forEach((link) => replaceLink(link, "Log out", "/account/logout/"));
			registerLinks.forEach((link) => replaceLink(link, "Account", "/account/"));
		} else {
			loginLinks.forEach((link) => replaceLink(link, "Log in", "/account/login/"));
			registerLinks.forEach((link) => replaceLink(link, "Register", "/account/register/"));
		}
	}

	clearCustomer() {
		removeCookie("accessToken");
		removeCookie("customerId");
		this.customerToken = null;
		this.customerObj = null;
		this.updateAccountLinks();
		// We need do logout from shopify checkout
		// after it returns back to homepage
		window.location = `https://${cartDomain}/account/logout/`;
	}
}

// Initialize
window.addEventListener("load", () => {
	// Check for discount parameter and add to a cookie
	checkForDiscountCode();

	// Check and fetch checkout
	const location = window.location.pathname;
	const path = location.split("/")[1];
	const doNotFetchCheckout = ["cart", "delivery-details", "products", "extras"];
	if (!doNotFetchCheckout.includes(path)) {
		const core = new Core();
		core.fetchCheckout();
	}

	// check and initialize tooltips
	tooltip();

	// Check if there's subscription row
	const subscriptionRow = document.querySelectorAll(".subscription-row");
	if (Array.from(subscriptionRow).length > 0) {
		addScript("/assets/js/subscription.js", () => {
			Array.from(subscriptionRow).forEach((subsComp) => new Subscription(subsComp));
		});
	}

	const searchBtn = document.querySelector("#searchLink > button");
	searchBtn.addEventListener("click", () => {
		const isOpen = searchBtn.parentElement.classList.toggle("open");
		if (isOpen) {
			setTimeout(() => {
				searchBtn.parentElement.querySelector("input").focus();
			}, 250);
		}
	});
});

// Previous & Next Buttons on CSS Slider

function handleSliderNavigationButtonClick(evt, slider) {
	let { direction } = evt.currentTarget.dataset;
	direction = Number(direction);
	if (!direction) return;
	const scrollXAmount = slider.firstElementChild.scrollWidth * direction;
	slider.scrollBy(scrollXAmount, 0);
}

function handleSliderScroll(slider, navigationButtons) {
	const prevButton = navigationButtons.find((btn) => btn.dataset.direction === "-1");
	const nextButton = navigationButtons.find((btn) => btn.dataset.direction === "1");

	if (prevButton) {
		if (slider.scrollLeft === 0) {
			prevButton.classList.add("scroll-end");
		} else {
			prevButton.classList.remove("scroll-end");
		}
	}
	if (nextButton) {
		if (slider.scrollWidth <= slider.clientWidth + slider.scrollLeft) {
			nextButton.classList.add("scroll-end");
		} else {
			nextButton.classList.remove("scroll-end");
		}
	}
}

function addSliderNavigationButtonHandlers(container) {
	if (!container) return;
	const slider = container.querySelector("[data-slider]");
	if (!slider) return;
	const navigationButtons = container.querySelectorAll("[data-direction]");
	if (!navigationButtons) return;
	slider.addEventListener("scroll", () => handleSliderScroll(slider, [...navigationButtons]));
	navigationButtons.forEach((btn) =>
		btn.addEventListener("click", (evt) => handleSliderNavigationButtonClick(evt, slider))
	);
}

document
	.querySelectorAll(".product-slider-wrapper")
	.forEach((container) => addSliderNavigationButtonHandlers(container));

function closeAppBanner({ target }) {
	const closeButton = target.closest("[data-af-close-button]");
	if (!closeButton) return;
	if (typeof AF === "function") AF("banners", "hideBanner");
	document.removeEventListener("click", closeAppBanner);
}

document.addEventListener("click", closeAppBanner);

function addScrolledClass() {
	document.documentElement.classList.add("scrolled");
	document.removeEventListener("scroll", addScrolledClass);
}

document.addEventListener("scroll", addScrolledClass);

function createFooterObserver() {
	const headerElement = document.querySelector("body > header");
	const footerElement = document.querySelector("body > footer");
	if (!headerElement || !footerElement || typeof window.IntersectionObserver !== "function") return;

	function callback(entries) {
		entries.forEach((entry) => {
			headerElement.classList.toggle("stick", !entry.isIntersecting);
		});
	}
	const options = {
		root: null,
		rootMargin: "0px",
		threshold: 0.5,
	};

	const footerObserver = new IntersectionObserver(callback, options);
	footerObserver.observe(footerElement);
}

createFooterObserver();

let mobileDisplay = true;
function openFooterColumnsOnDesktop() {
	const mediaQuery = window.matchMedia("(min-width: 1025px)");
	const footerDetails = document.querySelectorAll("footer .upper details");
	if (mediaQuery.matches) {
		mobileDisplay = false;
		footerDetails.forEach((detailsEle) => detailsEle.setAttribute("open", ""));
	} else if (!mobileDisplay) {
		mobileDisplay = true;
		footerDetails.forEach((detailsEle) => detailsEle.removeAttribute("open"));
	}
}

openFooterColumnsOnDesktop();

function setUspBarMinHeight(ele) {
	const uspBar = ele || document.querySelector("header .upper-nav");
	if (!uspBar) return;
	const usps = uspBar.querySelectorAll("div");
	if (!usps || !usps.length) return;
	let maxLines = 1;
	for (let i = 0; i < usps.length; i += 1) {
		const usp = usps[i];
		const divHeight = usp.offsetHeight;
		const lineHeight = parseInt(window.getComputedStyle(usp).getPropertyValue("line-height"), 10);
		const numLines = divHeight / lineHeight;
		maxLines = Math.max(maxLines, numLines);
	}
	uspBar.style.setProperty("--maxLines", `${maxLines}`);
}
setUspBarMinHeight();

/* Loop through all callouts */
function switchCallout() {
	const callouts = document.querySelectorAll("header .upper-nav > div");
	if (!callouts) return;
	const activeClass = "active-callout";
	let activeCalloutFound = false;
	for (let i = 0; i < callouts.length; i += 1) {
		const callout = callouts[i];
		if (callout.classList.contains(activeClass)) {
			activeCalloutFound = true;
			callout.classList.remove(activeClass);
			const nextIndex = i + 1 < callouts.length ? i + 1 : 0;
			setTimeout(() => callouts[nextIndex].classList.remove("opacity-0"), 500);
			callouts[nextIndex].classList.add(activeClass, "opacity-0");
			return;
		}
	}
	if (activeCalloutFound) return;
	setTimeout(() => callouts[0].classList.remove("opacity-0"), 500);
	callouts[0].classList.add(activeClass, "opacity-0");
}

setInterval(switchCallout, 2000);

// Windows Screen Resizes Function
window.onresize = () => {
	openFooterColumnsOnDesktop();
	setUspBarMinHeight();
};
